import { isGoToWebProjectAction } from '@/browser/goToWebProject';
import { isRecord, isString } from '@/utils/validator';
import { sendCommand } from '@/core/command';

import type { ActionGoToWebProjects } from '@/browser/goToWebProject';
import type { Validator } from '@/utils/validator';

type AllowedOnCloseAction = ActionGoToWebProjects;

const validators = {
  goToWebProject: isGoToWebProjectAction,
} as Record<string, Validator<any>>;

function isAllowedOnCloseAction(a: unknown): a is AllowedOnCloseAction {
  if (!isRecord(a)) {
    return false;
  }

  const actionId = a.actionId;
  if (!isString(actionId)) {
    return false;
  }

  const validate = (validators as Record<string, Validator<any>>)[actionId];
  return validate ? validate(a) : false;
}

enum SetOnCloseActionMode {
  APPEND = 'append',
  REPLACE = 'replace',
}

export function setOnCloseActionsQueue(actions: AllowedOnCloseAction[], replaceExisting = true) {
  const invalidIndex = actions.findIndex((a) => !isAllowedOnCloseAction(a));
  if (invalidIndex !== -1) {
    throw new Error(`setOnCloseActionsQueue: action at index ${invalidIndex} is not allowed/invalid`);
  }

  return sendCommand({
    command: 'action',
    params: {
      actionId: 'setOnCloseActions',
      mode: replaceExisting ? SetOnCloseActionMode.REPLACE : SetOnCloseActionMode.APPEND,
      actions: actions,
    },
  });
}
